import { footerColumns, navItems, siteMeta } from '@/mocks/home';

export default function SiteFooter() {
  return (
    <footer className="w-full border-t-2 border-foreground-950 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.3fr_2fr]">
          <div>
            <div className="flex items-center gap-3">
              <div className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-contrast-2-line text-xl" />
              </div>
              <div>
                <p className="font-label text-[10px] uppercase tracking-[0.3em] text-foreground-500">
                  {siteMeta.latinName}
                </p>
                <p className="font-heading text-xl font-black text-foreground-950">{siteMeta.name}</p>
              </div>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-foreground-600">{siteMeta.slogan}</p>
            <p className="mt-4 max-w-sm border-l-2 border-accent-500 pl-3 text-xs leading-relaxed text-foreground-500">
              本站内容均为公开渠道信息整理，按时间线与身份分类呈现，不构成对任何个人的评价或结论。请保持独立判断。
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            {footerColumns.map((column) => (
              <nav key={column.title} aria-label={column.title}>
                <h3 className="font-heading text-sm font-bold text-foreground-950">{column.title}</h3>
                <ul className="mt-4 space-y-2.5">
                  {column.links.map((link) => (
                    <li key={link}>
                      <a
                        href="#dossier"
                        className="font-label text-sm text-foreground-600 transition-colors hover:text-primary-600"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </nav>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-wrap gap-x-5 gap-y-2 border-t border-foreground-950/15 pt-6">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="font-label text-xs text-foreground-600 transition-colors hover:text-primary-600"
            >
              {item.label}
            </a>
          ))}
        </div>

        <div className="mt-6 flex flex-col items-start justify-between gap-3 border-t border-foreground-950/15 pt-6 sm:flex-row sm:items-center">
          <p className="font-label text-xs text-foreground-500">
            © 2026 {siteMeta.name} · {siteMeta.editor}
          </p>
          <p className="font-label text-xs text-foreground-500">
            明星 · 网红 · 主播 · 公众人物 — 统一归档
          </p>
        </div>
      </div>
    </footer>
  );
}